import { CustomizacaoSubmenuEnum } from './../../shared/enums/CustomizacaoSubmenuEnum';

import { AfterViewChecked, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CedenteService } from 'src/app/services/cedente.service';
import { PerfilService } from 'src/app/services/perfil.service';
import { CustomizacaoMenuEnum } from './../../shared/enums/CustomizacaoMenuEnum';

import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { AllocatedBalance } from 'src/app/models/balance';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { Colaborador } from 'src/app/models/colaborador';
import { Perfil } from 'src/app/models/perfil';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BalanceService } from 'src/app/services/balance.service';
import { CardNameBroadcastServiceService } from 'src/app/services/card-name-broadcast-service.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { GroupService } from 'src/app/services/group/group.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { SaldoCedenteService } from 'src/app/services/saldo-cedente.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { PerfilNormalizado } from 'src/app/shared/enums/perfil-normalizado.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { ColaboradorService } from '../../services/colaborador.service';

@Component({
    selector: 'app-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.css']
})
export class PortalComponent implements OnInit, OnDestroy, AfterViewChecked {
    // Variaveis Navbar/Navblock
    isNavbarCollapsed = true;
    isCadastroCollapsed = true;
    isProdutoCollapsed = true;
    isAdministrativoCollapsed = true;
    isPedidoCollapsed = true;
    isFinanceiroCollapsed = true;

    public accessCadastro = false;
    public accessProduto = false;
    public accessAdministrativo = false;
    public accessPedido = false;
    public accessFinanceiro = false;
    public accessCartaoFisico = false;
    public accessRelatorio = false;

    public saldoDisponivel = 0;
    public isSaldoAtt = false;
    public urlAtual = '';
    private cedenteContrato: CedenteContrato[];
    private colaboradoresList: Colaborador[];
    public nomeEmpresa = '';
    public showAvailableBalance = false;
    public exibirMenusGrupo = false;
    public trocarCedente = false;

    public currentAccountBalance: number =0;
    public isCurrentAccountBalanceLoading = true;
    public allocatedBalances: AllocatedBalance[];
    public isAllocatedBalancesLoading = true;

    public notificacoes: any;
    public unreadNotifications: any;

    public customizacaoMenuEnum = CustomizacaoMenuEnum;
    public customizacaoSubmenuEnum = CustomizacaoSubmenuEnum;

    @ViewChild('noContrato', { static: true }) noContrato: TemplateRef<any>;
    @ViewChild('noColaborador', { static: true }) noColaborador: TemplateRef<any>;

    menuAdministrativoLabel = 'Administrativo';
    submenuGestoresLabel = 'Gestores';
    temEndereco = false;
    temInscricaoMunicipal = false;
    temDadoBancario = false;
    temContaSeuValeLog = false;
    temContaDespesas = false;

    constructor(
        private cedenteService: CedenteService,
        private perfilService: PerfilService,
        private alertService: NewAlertService,
        private router: Router,
        private authenticationService: AuthenticationService,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private contratoService: ContratoService,
        private colaboradorService: ColaboradorService,
        private cardNameBroadcastServiceService: CardNameBroadcastServiceService,
        private parametrosDataService: ParametrosDataService,
        private saldoCedenteService: SaldoCedenteService,
        private groupService: GroupService,
        private notificacaoService: NotificacaoService,
        private balanceService: BalanceService
    ) { }

    private currentUser: Auth;

    ngOnInit() {
        this.cardNameBroadcastServiceService
            .GetCardName()
            .subscribe(response => (this.nomeEmpresa = response));

        this.currentUser = this.authenticationService.currentUserValue;
        if (this.currentUser) {
            this.cedenteService
                .getAll(this.currentUser.token.userReferenceId)
                .subscribe(
                    response => {
                        if (response.result.length === 1) {
                            this.currentUser.token.assignorGuid =
                                response.result[0].cedenteGuid;
                        } else if (
                            response.result.length > 1 &&
                            this.currentUser.token.assignorGuid === null
                        ) {
                            this.router.navigate(['selectassignor']);
                        }
                    },
                    error => {
                        // this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                        console.log(error);
                        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                        this.logout();
                    }
                );
        } else {
            this.logout();
        }



        // Carregar perfis do gestor em relação a cedente
        this.perfilService
            .getAll(
                this.currentUser.token.userReferenceId,
                this.currentUser.token.assignorGuid
            )
            .subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.loadMenu(response.result);
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    // this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                    console.log(error);
                    this.alertService.error('Ocorreu um erro ao tentar carregar o perfil do gestor');
                    this.logout();
                }
            );

        //this.saldoCedenteService.saldoAtual.subscribe(message => this.saldoDisponivel = message);
        //this.saldoCedenteService.atualizarSaldo(this.currentUser.token.assignorGuid);

        this.nomeEmpresa = this.currentUser.token.assignorName;
        if(JSON.parse(localStorage.getItem('assignorInfo')) == null || JSON.parse(localStorage.getItem('assignorInfo')) == undefined){
        this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid,this.currentUser.token.userReferenceId, true)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    localStorage.setItem('assignorInfo', JSON.stringify(response.result));
                } else {
                    this.alertService.error(response.message);
                }
            });
        }

        this.cedenteService
            .getParametros(
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId
            )
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    // carregar parametros
                    this.parametrosDataService.setCurrentParametrosValue(
                        response.result
                    );
                    this.loadParametros();
                    this.loadNotifications();
                    this.getNotifications(this.currentUser.token.pessoaId);
                }
            });

        this.trocarCedente = this.currentUser?.assignors?.length > 1;

        this.getCurrentAccountBalance();
    }
    ngAfterViewChecked() {


        if(this.router.routerState.snapshot.url !== this.urlAtual){

            this.urlAtual = this.router.routerState.snapshot.url;
            this.isSaldoAtt = false;
        }

        if (this.isSaldoAtt  === false) {
            this.saldoCedenteService.saldoAtual.subscribe(message => this.saldoDisponivel = message);
            this.saldoCedenteService.updateBalance(this.currentUser.token.assignorGuid);
            this.saldoCedenteService.updateCurrentAccountBalance(this.currentUser.token.assignorGuid);
            this.isSaldoAtt = true;
        }

    }

    loadMenu(perfis: Perfil[]) {
        this.accessCadastro = perfis.some(
            x =>
                x.nomeNormalizado === PerfilNormalizado.Cadastro ||
                x.nomeNormalizado === PerfilNormalizado.Responsavel
        );
        this.accessProduto = perfis.some(
            x =>
                x.nomeNormalizado === PerfilNormalizado.Beneficio ||
                x.nomeNormalizado === PerfilNormalizado.Responsavel
        );
        this.accessAdministrativo = perfis.some(
            x =>
                x.nomeNormalizado === PerfilNormalizado.Administrativo ||
                x.nomeNormalizado === PerfilNormalizado.Responsavel
        );
        this.accessPedido = perfis.some(
            x =>
                x.nomeNormalizado === PerfilNormalizado.Pedido ||
                x.nomeNormalizado === PerfilNormalizado.Responsavel
        );
        this.accessFinanceiro = perfis.some(
            x =>
                x.nomeNormalizado === PerfilNormalizado.Financeiro ||
                x.nomeNormalizado === PerfilNormalizado.Responsavel
        );
        this.accessCartaoFisico = perfis.some(
            x =>
                x.nomeNormalizado === PerfilNormalizado.CartaoFisico ||
                x.nomeNormalizado === PerfilNormalizado.Responsavel
        );
        this.accessRelatorio = perfis.some(
            x =>
                x.nomeNormalizado === PerfilNormalizado.Relatorio ||
                x.nomeNormalizado === PerfilNormalizado.Responsavel
        );
    }

    loadParametros() {
        const parametros = this.parametrosDataService.currentParametrosValue;

        if (parametros) {

            if (parametros[ParametrosKey.exibirSaldoCedente]) {
                this.showAvailableBalance = BooleanConverter.getBoolean(parametros[ParametrosKey.exibirSaldoCedente]);
            } else {
                this.showAvailableBalance = true;
            }

            if (parametros[ParametrosKey.labelPersonalizadaMenuAdministrativo]) {
                this.menuAdministrativoLabel = parametros[ParametrosKey.labelPersonalizadaMenuAdministrativo];
            }

            if (parametros[ParametrosKey.temContaFlexivel]) {
                this.exibirMenusGrupo = parametros[ParametrosKey.temContaFlexivel];
            }

            if (parametros[ParametrosKey.labelPersonalizadaSubmenuGestores]) {
                this.submenuGestoresLabel = parametros[ParametrosKey.labelPersonalizadaSubmenuGestores];
            }

            if (parametros[ParametrosKey.temEndereco]) {
                this.temEndereco = BooleanConverter.getBoolean(parametros[ParametrosKey.temEndereco]);
            }

            if (parametros[ParametrosKey.temInscricaoMunicipal]) {
                this.temInscricaoMunicipal = BooleanConverter.getBoolean(parametros[ParametrosKey.temInscricaoMunicipal]);
            }

            if (parametros[ParametrosKey.temDadoBancario]) {
                this.temDadoBancario = BooleanConverter.getBoolean(parametros[ParametrosKey.temDadoBancario]);
            }

            if (parametros[ParametrosKey.temContaSeuValeLog]) {
                this.temContaSeuValeLog = BooleanConverter.getBoolean(parametros[ParametrosKey.temContaSeuValeLog]);
            }
            
            if (parametros[ParametrosKey.temContaDespesas]) {
                this.temContaDespesas = BooleanConverter.getBoolean(parametros[ParametrosKey.temContaDespesas]);
            }
        }
    }

    getNotifications(pesornId){
        this.notificacaoService.getListNotification(pesornId,0,7,0)
        .subscribe(response => {
            if (response.status === ApiError.Sucesso) {
                this.notificacoes = response.result.notificacoes;
            }
        });

        // this.notificacaoService
        // .getUnreadNotification(this.currentUser.token.pessoaId)
        // .subscribe(response => {
        //     if (response.status === ApiError.Sucesso) {
        //         this.unreadNotifications = response.result.unreadNotifications;
        //     }
        // });
    }

    getBalances(e: any){
        console.log(e)
        this.getCurrentAccountBalance();
        this.getAllocatedBalances();
    }

    getCurrentAccountBalance(){
        this.isCurrentAccountBalanceLoading = true;

        this.balanceService.getCurrentAccountBalance(this.currentUser.token.assignorGuid)
            .subscribe(
                response => {
                    this.isCurrentAccountBalanceLoading = false;
                    if(response.status === ApiError.Sucesso){
                        this.currentAccountBalance = response.result;
                    }
                    else {
                        this.alertService.error(response.message);
                    }
                }, error => {console.log(error.message)}
            )
    }

    getAllocatedBalances(){
        this.isAllocatedBalancesLoading = true;

        this.balanceService.getAllocatedBalances(this.currentUser.token.assignorGuid)
            .subscribe(
                response => {
                    this.isAllocatedBalancesLoading = false;
                    if(response.status === ApiError.Sucesso){
                        this.allocatedBalances = response.result;
                    }
                    else {
                        this.alertService.error(response.message);
                    }
                }, error => {console.log(error.message)}
            )
    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['auth']);
    }

    ChangeAssignor(){
        console.log(this.currentUser.accessToken);
        this.authenticationService.getAssignorTransitoryToken(this.currentUser.token.accessToken).subscribe(
            response => {
                // pin enviado -> redirecionar para login-pin
                if (response.status === ApiError.Sucesso) {
                    this.currentUser.assignors = response.result.assignors;
                    this.authenticationService.setCurrentUserValue(this.currentUser);
                    this.router.navigate(['selectassignor']);
                } else {
                    this.alertService.error(response.message);
                }
            }
        );
    }

    navigateToHome() {
        this.router.navigate(['portal']);
        this.isNavbarCollapsed = true;
    }

    navigateToCentroCusto() {
        this.router.navigate(['centrocusto'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToColaborador() {
        this.router.navigate(['colaborador'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToUnidade() {
        this.router.navigate(['unidade'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToDepartamento() {
        this.router.navigate(['departamento'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToGestor() {
        this.router.navigate(['gestor'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToGestorConvites() {
        this.router.navigate(['gestor/list-accepted'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToGestaoBeneficio() {
        this.router.navigate(['gestao-beneficio/list'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToDadoEmpresa() {
        this.router.navigate(['dadoempresa'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToDadoBancario() {
        this.router.navigate(['dadobancario'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToNovoBeneficio() {
        this.router.navigate(['novobeneficio'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToContrato() {
        this.router.navigate(['contrato'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToExtratoPedidos() {
        this.router.navigate(['extrato-pedido'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToExtratoRecargas() {
        this.router.navigate(['extrato-recarga'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToExtrato() {
        this.router.navigate(['extrato'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToExtratoLog(){
        this.router.navigate(['portal/extrato-log/list']);
    }

    navigateToDepositos() {
        this.router.navigate(['deposito'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToDepositosPagamentos() {
        this.router.navigate(['depositos-pagamentos'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToNovoPedido() {
        this.router.navigate(['portal/novopedido/create']);
    }

    navigateToNovarecarga() {
        this.router.navigate(['portal/novarecarga/create']);
    }


    navigateToNovoGrupo() {
        this.groupService.clearRascunho();
        this.router.navigate(['portal/grupos/create']);
    }

    navigateToGruposList() {
        this.router.navigate(['portal/grupos/list']);
    }

    navigateToMeusPedidos() {
        this.router.navigate(['meuspedidos'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToMinhasRecargas() {
        this.router.navigate(['minhasrecargas'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToPagamentos() {
        this.router.navigate(['pagamentos'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToCardsStatus(){
        this.router.navigate(['cartao/status-list'], { relativeTo: this.route });
        this.isNavbarCollapsed = true;
    }

    navigateToCartoesFisicos(){
        this.router.navigate(['portal/cartoes/list']);
    }

    navigateToPedidoCartoesFisicos(){
        this.router.navigate(['portal/cartoes/novopedido']);
    }

    navigateToNotificaoList(){
        this.router.navigate(['portal/notificacao/notificacao-list']);
        this.isNavbarCollapsed = true;
    }

    navigateToRelatorioFavorecidoDetalhado(){
        this.router.navigate(['portal/relatorio/relatorio-favorecido']);
    }

    navigateToRelatorioFavorecidoConsolidada(){
        this.router.navigate(['portal/relatorio/favorecido-consolidada']);
    }

    navigateToRelatorioSaldoDetalhado(){
        this.router.navigate(['portal/relatorio/saldo-detalhado']);
    }

    navigateToRelatorioSaldoConsolidado(){
        this.router.navigate(['portal/relatorio/saldo-consolidado']);
    }

    navigateToRelatorioExtrato(){
        this.router.navigate(['portal/relatorio/extrato-relatorio']);
    }

    navigateToRelatorioCredito(){
        this.router.navigate(['portal/relatorio/credito-relatorio']);
    }

    navigateToRelatorioRecargas(){
        this.router.navigate(['portal/relatorio/recargas-relatorio']);
    }

    navigateToSituacaoCadastro(){
        this.router.navigate(['portal/relatorio/situacao-cadastro']);
    }

    navigateToSituacaoCartao(){
        this.router.navigate(['portal/relatorio/situacao-cartao']);
    }

    navigateToSolicitacaoCartao(){
        this.router.navigate(['portal/relatorio/solicitacao-cartao']);
    }

    navigateToTransacoesSaldoAlocado(){
        this.router.navigate(['portal/relatorio-despesas/transacoes']);
    }

    navigateToCreditoSaldoAlocado(){
        this.router.navigate(['portal/relatorio-despesas/creditos']);
    }

    navigateToSaldosAlocados(){
        this.router.navigate(['portal/saldo-alocado']);
    }

    navigateToVeiculos(){
        this.router.navigate(['portal/veiculos/list']);
    }

    navigateToCondutor(){
        this.router.navigate(['portal/condutor/list']);
    }

    navigateToConsumo(){
        this.router.navigate(['portal/relatorio-log/consumo']);
    }

    navigateToValidadeCnh(){
        this.router.navigate(['portal/relatorio-log/validade-cnh']);
    }

    ChangePassword(){
        this.router.navigate(['portal/redefinir-senha']);
    }

    showModal(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    ShowMenu(menuEnum: CustomizacaoMenuEnum) {
        return this.parametrosDataService.ShowMenu(menuEnum);
    }

    ShowSubmenu(submenuEnum: CustomizacaoSubmenuEnum) {
        return this.parametrosDataService.ShowSubmenu(submenuEnum);
    }

    loadNotifications() {
        const options = {
            autoClose: false,
            keepAfterRouteChange: true
        };

        if (!this.temEndereco) {
            this.alertService.notificationWarning(
                'Endereço',
                'Você ainda não informou o seu endereço, para cadastrar navegue até Administrativo > Dados da empresa',
                options
            );
        }

        // if (!this.temDadoBancario) {
        //     this.alertService.notificationWarning(
        //         'Dado Bancário',
        //         'Você ainda não informou nenhum dado bancário, para cadastrar navegue até Administrativo > Dados bancários',
        //         options
        //     );
        // }
    }

    ngOnDestroy(){
        localStorage.removeItem('passos');
        localStorage.removeItem('tutorial');
        localStorage.removeItem('assignorInfo');
    }
}
